import { Component, OnInit } from '@angular/core';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import {Angular2CsvModule} from 'angular2-csv';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
declare var getHexAscii: any;
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';


@Component({
  selector: 'app-atmcardblock',
  templateUrl: './atmcardblock.component.html',
  styleUrls: ['./atmcardblock.component.css']
})
export class AtmcardblockComponent implements OnInit {
  scAccounts: any [];
  accountInfo: any ;
  status:string='';
  custNo:string='';
  debitCardAcct : string ='';
  balance : string ='';
  selectedStopPayment : string ='';
  selectedBalance : string='';
  crr : string='';
  stopPaymentAcct : string='';
  selectedCurrencyCode : string='';
  isShow : string='page1';
  debitCardAddress : any;
  transactionPin : string ='';
  error : string ='';
  cardCat : string ='';
  EmbossingName : string ='';
  otp : string ='';
  debitCardNumber : string='' ;
  addressDetails : any=[];
  disableSub1Btn:boolean=false;
  disableSub2Btn:boolean=false;
  cardAccRequired:string='';
  cardNoRequired:string='';
  otpRequired:string='';
  isCardError:boolean=false;
  showError:string="";
  generatedOtp : string='';
  invalidOTP : string='';
  successMsg:string="";
  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) {
    this.scAccounts =JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.accountInfo=JSON.stringify(JSON.parse(sessionStorage.getItem('accountInfo')));

  }

  getBalanceAndCrr()
  {
     this.spinnerService.show();
    this.cardNoRequired='';
    const request: IbRequest = new IbRequest();
    const response: IbResponse = null;
    request.param1 = getHexAscii('', this.debitCardAcct);
    request.param2 = this.debitCardAcct;
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
       this.spinnerService.hide();
      if (data !== null && data.status === 'S200') {
        this.balance = data.param5.clrBalanceStr;
        this.selectedStopPayment = this.stopPaymentAcct;
        this.selectedBalance = this.balance;
        this.crr = 'INR';
        this.selectedCurrencyCode =  this.crr;
        console.log('efaf'+this.balance+this.selectedStopPayment+this.selectedBalance);

      } else{
        alert(data);
      }
    });
  }
  submotFirst(){
    this.cardAccRequired='';
    this.debitCardNumber='';
    this.showError='';
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
console.log("ACC--"+this.debitCardAcct);
console.log("ACC--"+sessionStorage.getItem('custNo'));
    if(this.debitCardAcct){
      console.log('Input : ' +getHexAscii("",this.debitCardAcct));
     this.spinnerService.show();
      request.param1 = getHexAscii("",this.debitCardAcct);
      request.param2 = this.debitCardAcct;
      // request.param3=sessionStorage.getItem('custNo');
      request.param3=sessionStorage.getItem('cardNo');
      //request.param5=this.addrType;
      this.webService.getResponse(request, 'getCardId').subscribe((data: IbResponse) => {
        // this.webService.getResponse(request, 'getCardList').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        this.debitCardAddress=data;
        if (this.debitCardAddress.status === 'S101'){
          alert('Malicious Request Detected');
        }
        if(this.debitCardAddress.status==='S200'){
          this.addressDetails= this.debitCardAddress.param6;

        }else
        {
          this.showError=data.param1;
          this.isCardError=true;
        }
      });
    }
  }

  //generate OTP
  submotSecond(){
    if(this.debitCardAcct===""||this.debitCardAcct===" "||this.debitCardAcct===undefined)
    {
      this.cardAccRequired='no';
    }else if(this.debitCardNumber===""||this.debitCardNumber===" "||this.debitCardNumber===undefined){
      this.cardNoRequired='no';
    }else{

      this.disableSub1Btn=true;
       this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("come inside");
      //this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName')+this.debitCardAcct+this.debitCardNumber);
      request.param2 =sessionStorage.getItem('storedUserName');
      request.param3 = this.debitCardAcct;
      request.param4=this.debitCardNumber;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
          this.isShow = 'page2';
          this.generatedOtp=response.param1;
          this.disableSub1Btn=false;
        } else if (response !== null) {
          this.error = response.param1;
          this.disableSub1Btn=false;
        } else {
          this.disableSub1Btn=false;
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  submotIOTP1()
  {
    if(this.otp===""||this.otp===" "||this.otp===undefined)
    {
      this.otpRequired='no';
    }
    else if(this.otp!== this.generatedOtp)
    {
      this.invalidOTP='no';
    }
    else{
      this.disableSub2Btn=true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("come inside");
      //this.isLoad = true;
      request.param1 = getHexAscii('', this.debitCardAcct+this.debitCardNumber+this.status+this.custNo+sessionStorage.getItem('storedUserName'));
      request.param2 = this.debitCardAcct;
      request.param3 = this.debitCardNumber;
      // request.param4 = getHexAscii('',this.otp);
      request.param4 = this.status;
       request.param5=sessionStorage.getItem('storedUserName');
       request.param6=this.custNo;
       this.spinnerService.show();
      this.webService.getResponse(request, 'cardBlock').subscribe((data: IbResponse) => {
        response = data;
         this.spinnerService.hide();
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
           this.successMsg=response.param1;
          this.isShow = 'page3';
         
        } else if (response !== null) {
          this.error = response.param1;
          this.disableSub2Btn=false;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.disableSub2Btn=false;
        }
      });
    }
  }

  submotIOTP()
  {
    /*if(this.otp===""||this.otp===" "||this.otp===undefined)
    {
      this.otpRequired='no';
    }
    else if(this.otp!== this.generatedOtp)
    {
      this.invalidOTP='no';
    }
    else{*/
    console.log("Card Block");
      this.disableSub2Btn=true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("come inside");
      //this.isLoad = true;
      request.param1 = getHexAscii('', this.debitCardAcct+this.debitCardNumber+this.otp+sessionStorage.getItem('storedUserName'));
      request.param2 = this.debitCardAcct;
      request.param3 = this.debitCardNumber;
      request.param4 = getHexAscii('',this.otp);
       request.param5=sessionStorage.getItem('storedUserName');
       this.spinnerService.show();
      this.webService.getResponse(request, 'cardBlock').subscribe((data: IbResponse) => {
        response = data;
         this.spinnerService.hide();
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
           this.successMsg=response.param1;
          this.isShow = 'page3';
         
        } else if (response !== null) {
          this.error = response.param1;
          this.disableSub2Btn=false;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.disableSub2Btn=false;
        }
      });
    //}
  }
  ngOnInit() { 
    $(document).ready(function() {
    $('input').bind('copy paste cut',function(e) { 
    e.preventDefault(); //disable cut,copy,paste
    });
   });
  }
  validateOtp(){
    if(this.otp===""||this.otp===" "||this.otp===undefined)
    {
      this.otpRequired='no';
    }
  }
  removeOtpMsgs(){
    this.otpRequired='';
    this.invalidOTP='';
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/atmcardblock/atmcardblock.component.ts